import script from "./RecommendationsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendationsView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__